export const FoodExpo2026MapInformation = {
  venue: "foodexpo2026",
  venueId: "2313693d-7aee-43e5-9d3c-4fc22bcad15a",
  i18nVenue: "food_expo_2026",
  venueName: "HKCEC Hall 1ABCD",
  venueName_zh: "HKCEC Hall 1ABCD",
  floorAlignment: [
    {
      lcMapId: "140751a9-666a-4aef-94f1-43d5d4b761e9",
      id: "b14e2402-2cb3-4f68-b235-9ee94dd069f3",
      ordinal: 1,
      name: "foodexpo2026",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/ebba263b-e3a9-491a-924a-ff1da609a51f/m13-1774938068936BAMUTI.jpg",
      pixInMeter: 10.83130246437555,
      center: { lat: 22.28308785302944, lng: 114.17297960082531 },
      angle: 86.2,
      scale: 92.325,
      corners: {
        tl: { lat: 22.28401928372865, lng: 114.17324143156486 },
        tr: { lat: 22.282196647107835, lng: 114.1733722589604 },
        br: { lat: 22.28215642035228, lng: 114.17271777197197 },
        bl: { lat: 22.283979060929028, lng: 114.17258694004545 },
      },
      size: { width: 2200, height: 731 },
      sizeInMeters: { width: 203.1147649628199, height: 67.48979493224243 },
    },
  ],
  name: "L0",
  imageUrl:
    "https://locaite-dev.collectiv.co/assets/ebba263b-e3a9-491a-924a-ff1da609a51f/m13-1774536795904SOSOXU.jpg",
  pixInMeter: 10.83130246437555,
  center: {
    lat: 22.28308785302944,
    lng: 114.17297960082531,
  },
  angle: 86.2,
  scale: 92.325,
  corners: {
    tl: {
      lat: 22.28401928372865,
      lng: 114.17324143156486,
    },
    tr: {
      lat: 22.282196647107835,
      lng: 114.1733722589604,
    },
    br: {
      lat: 22.28215642035228,
      lng: 114.17271777197197,
    },
    bl: {
      lat: 22.283979060929028,
      lng: 114.17258694004545,
    },
  },
  size: {
    width: 2200,
    height: 731,
  },
  sizeInMeters: {
    width: 203.1147649628199,
    height: 67.48979493224243,
  },
  mapData: [{ id: "L1", name: "L1", level: 1 }],
  modelConfig: {
    folderPath: "venue/food_expo_2026/",
    defaultPosition: [-1106.579, 25, -321.82],
    defaultTarget: [-1106.77, 25, -316.82],
    defaultFloorIndex: 1,
    defaultLcMapId: "140751a9-666a-4aef-94f1-43d5d4b761e9",
    topAltitude: 300,
    downSpeed: 200,
    scaleFactor: 16.2469536962,
    moveSpeed: 2,
    rotateSpeed: 20,
    revealSpeed: 30,
    splat: {
      mode: "singleLod",
      singleLod: "lod_20260409_1200/lod-meta.json",
    },
    mesh: {
      meshModels: [
        {
          index: 1,
          url: "extra_mesh/signage_20260404_1715.glb",
          position: [-1100, 0, -365.5],
          rotationAngle: [0, 180, 0],
          scale: [455, 455, 455],
          color: "#FFFFFF",
          opacity: 1,
          rotateObjects: [
            "signage_ageing",
            "signage_cheung_chau",
            "signage_first_aid",
            "signage_food_fun",
            "signage_gold_pig",
            "signage_jazz",
            "signage_lucky_draw_1",
            "signage_lucky_draw_2",
            "signage_lucky_draw_3",
            "signage_main_stage",
            "signage_market",
            "signage_redemp_1",
            "signage_redemp_2",
            "signage_silk_road",
            "signage_vintage",
            "signage_whimsy",
          ],
        },
      ],
    },
    floor: [
      {
        lcMapId: "140751a9-666a-4aef-94f1-43d5d4b761e9",
        id: "b14e2402-2cb3-4f68-b235-9ee94dd069f3",
        index: 1,
        name: "L1",
        shortName: "L1",
        altitude: 25,
        topViewModel: "l1/L1_topView_20260612_1030_16tiles.glb",
        yAxis: 25,
      },
    ],
  },
};
